export class MaterialSellingHistory {
  orderDate?: Date;
  orderNumber?: string;
  orderStatus?: string;
  customer?: string;
  salesman?: string;
  unitOrdered?: number;
  unitPrice?: number;
  total?: number;
  orderId?: number;
  loc?: string;
}
